<p-card>

   <div class="grid" >
    
      <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu" >
          <div class="text-end p-0 border-round-sm font-bold">
            <p-button *ngIf="userRole == '1' && createRight == 'Y'"  pTooltip="Add Currency" tooltipPosition="left" (click)="show('Add Currency','')" styleClass="customAdd p-button-sm p-button-raised mr-4" icon="fa fa-plus p-button-icon ng-star-inserted" ></p-button>
          <button class="fa fa-question helpicon" pTooltip="Help"
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','24')" tooltipPosition="bottom"
          aria-hidden="true"></button>
          </div>
      </div>
   
    </div>


  <div class="mr-0 tablehiegt">
    <p-table #dt [value]="currencylistarray" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal"
      [customSort]="customSort" (sortFunction)="this.utilityserv.customSort($event)"
      scrollHeight="{{categoryScrollHeight}}" [globalFilterFields]="['ct_currencyid','ct_currencyname','createdon','createdby','id','defaultflag']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
      paginatorLocale="fa-IR" [paginator]="true" [sortOrder]="1" responsiveLayout="scroll" [first]="currentPageIndex"
      (onPage)="handlePageChange($event)" sortField="ct_currencyname" [resizableColumns]="true"
      columnResizeMode="expand">

      <ng-template pTemplate="caption">
        <div class="grid table-header">
          <div class="col-12 md:col-10 sm:col-12 lg:col-10">
            <span class=" p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;" placeholder="Search in Currency"
                class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
            </span>
          </div>
          <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" (click)="exceldownloadModal=true">
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="userRole == '1'" style="width: 5% !important;">Action</th>
           <th pResizableColumn style="width: 10% !important;" pSortableColumn="ct_currencyid" tooltipPosition="left">Currency ID<p-sortIcon field="ct_currencyid"></p-sortIcon>
            <p-columnFilter type="text" field="ct_currencyid" display="menu"></p-columnFilter>
          </th>
          <th pResizableColumn style="width: 40% !important;" pSortableColumn="ct_currencyname" tooltipPosition="left">
            Currency Name<p-sortIcon field="ct_currencyname"></p-sortIcon>
            <p-columnFilter type="text" field="ct_currencyname" display="menu"></p-columnFilter>
          </th>

          <th pResizableColumn style="width: 12% !important;" pSortableColumn="defaultflag" tooltipPosition="left">Is
            Default<p-sortIcon field="defaultflag"></p-sortIcon>
            <p-columnFilter type="text" field="defaultflag" display="menu"></p-columnFilter>
          </th>
          <th pResizableColumn pSortableColumn="createdby" tooltipPosition="left">Created
            By<p-sortIcon field="createdby"></p-sortIcon>
            <p-columnFilter type="text" field="createdby" display="menu"></p-columnFilter>
          </th>
            <th pResizableColumn pSortableColumn="createdon" tooltipPosition="left">Created
            On<p-sortIcon field="createdon"></p-sortIcon>
            <p-columnFilter type="text" field="createdon" display="menu"></p-columnFilter>
          </th>
          <th pResizableColumn pSortableColumn="ct_statusflag" tooltipPosition="left">
            Status<p-sortIcon field="name"></p-sortIcon>
            <!-- <p-columnFilter type="text" field="ct_statusflag" display="menu"></p-columnFilter> -->
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data>
        <tr>
          <td *ngIf="userRole == '1'">
            <div>
              <span class="actionItm" pTooltip="Modify" tooltipPosition="left">
                <i class="fa fa-edit" (click)="show('Modify currency', data)"></i>
              </span>
            </div>
          </td>
          <td pTooltip="{{data.ct_currencyid}}" tooltipPosition="left"[innerHTML]="highlight(data.ct_currencyid, searchTerm)">
          <td pTooltip="{{data.ct_currencyname}}" tooltipPosition="left"[innerHTML]="highlight(data.ct_currencyname, searchTerm)">

          <!-- <td tooltipPosition="left" pTooltip="{{data.ct_currencyid}}">{{data.ct_currencyid}}</td>
          <td tooltipPosition="left" pTooltip="{{data.ct_currencyname}}">{{data.ct_currencyname}}</td> -->
          <td><span *ngIf="data.defaultflag === 'Y'" pTooltip="Yes" tooltipPosition="left" [innerHTML]="highlight(data.defaultflag === 'Y' ? 'Yes' : 'No', searchTerm)" >Yes</span>
            <span *ngIf="data.defaultflag !== 'Y'" pTooltip="No" tooltipPosition="left" [innerHTML]="highlight(data.defaultflag === 'Y' ? 'Yes' : 'No', searchTerm)">No</span>
          </td>
          <td pTooltip="{{data.createdby}}" tooltipPosition="left"[innerHTML]="highlight(data.createdby, searchTerm)">
          <td pTooltip="{{data.createdon}}" tooltipPosition="left"[innerHTML]="highlight(data.createdon, searchTerm)">
          <!-- <td tooltipPosition="left" pTooltip="{{data.createdby}}">{{data.createdby}}</td>
          <td tooltipPosition="left" pTooltip="{{data.createdon}}">{{data.createdon}}</td> -->
          <td>
            <span *ngIf="data.ct_statusflag === 'Y'" pTooltip="Active" tooltipPosition="left">
              <i class="fa fa-flag" style="color: green;"></i>
            </span>
            <span *ngIf="data.ct_statusflag !== 'Y'" pTooltip="Inactive" tooltipPosition="left">
              <i class="fa fa-flag" style="color: red;"></i>
            </span>
          </td>
        </tr>
      </ng-template>
       <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="datanotfound">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</p-card>


<p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [style]="{width: '42vw',height: '25%'}"
  [modal]="true" [baseZIndex]="10000" [draggable]="true" [resizable]="false">

  <div class="dialog-content-min-excel">
    <div class="card">
      <p>{{excel_paragraph}}</p>
    </div>
  </div>

  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="exceldownloadModal=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="excelData()"></p-button>
  </div>
</p-dialog>